import { render, staticRenderFns } from "./internal-document-dialog.vue?vue&type=template&id=d7c138c4&scoped=true&"
import script from "./internal-document-dialog.vue?vue&type=script&lang=js&"
export * from "./internal-document-dialog.vue?vue&type=script&lang=js&"
import style0 from "./internal-document-dialog.vue?vue&type=style&index=0&id=d7c138c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c138c4",
  null
  
)

export default component.exports